export default __webpack_public_path__ + "fdb8db2b79f410399cc47a1471c6df1b.png";